export default __webpack_public_path__ + "static/media/warning-icon-orange.c627a06c.svg";